import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import "./admin/css/PremiumImg.css"; // Import the CSS file with your gallery styles

const GalleryItem = ({ imageUrl, title }) => (
  <div className="gallery-item set-bg" style={{ backgroundImage: `url(${imageUrl})` }}>
    <div className="gi-text">
      <h3>{title}</h3>
    </div>
  </div>
);

const ImageGallery = () => {
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    const fetchImageUrls = async () => {
      try {
        // Replace 'premium' with the selected room type or get it from your component state
        const roomType = "small";
        const response = await axios.get(
          `http://localhost:3001/api/roomimages?roomType=${roomType}`
        );
        setImageUrls(response.data);
      } catch (error) {
        console.error("Error fetching image URLs:", error);
      }
    };

    fetchImageUrls();
  }, []);

  return (
    <div style={{ textAlign: "center", overflowX: "hidden" }}>
      <Header />
      <div className="row">
        <div className="col-lg-12">
          <div className="section-title">
            <h2>Small Room</h2>
          </div>
        </div>
      </div>
      <div className="container" style={{ marginTop: "-35px" }}>
        <div className="row">
          <div className="col-lg-6">
            <GalleryItem imageUrl={`http://localhost:3001${imageUrls[0]}`} title="Small Room 1" />
            <div className="row">
              <div className="col-sm-6">
                <GalleryItem imageUrl={`http://localhost:3001${imageUrls[1]}`} title="Small Room 2" />
              </div>
              <div className="col-sm-6">
                <GalleryItem imageUrl={`http://localhost:3001${imageUrls[2]}`} title="Small Room 3" />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <GalleryItem imageUrl={`http://localhost:3001${imageUrls[3]}`} title="Small Room 4" />
            <div className="row">
              <div className="col-sm-12">
                <GalleryItem imageUrl={`http://localhost:3001${imageUrls[4]}`} title="Small Room 5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;